"use client";

import { c as _c } from "react/compiler-runtime";
import { AccountLockup, AccountLockupAvatar, AccountLockupBadge } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { classNames, FlexCenter, SkeletonBlock, TABLE_SIZES, TextBodySkeleton, tableRowSizeVariants, tv } from "@opensea/ui-kit";
import { AccountEnforcementBadge } from "@/components/trustandsafety/AccountEnforcementBadge";
import { useAddress } from "@/hooks/wallet";
import { ExpandedSearch_accountFragment } from "../ExpandedSearch.fragment";
import { useExpandedSearchResultSize } from "./hooks";
const {
  container
} = tv({
  slots: {
    container: "h-16"
  }
})();
const randomAccountNameWidths = ["w-1/2", "w-1/3", "w-2/5", "w-3/5"];
export const mapAccountToSearchResultItem = accountKey => {
  const account = readFragment(ExpandedSearch_accountFragment, accountKey);
  return {
    id: account.address,
    data: accountKey,
    type: "account"
  };
};
export function ExpandedSearchAccountResult(t0) {
  const $ = _c(18);
  const {
    item,
    className
  } = t0;
  let t1;
  if ($[0] !== item.data) {
    t1 = readFragment(ExpandedSearch_accountFragment, item.data);
    $[0] = item.data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const account = t1;
  const size = useExpandedSearchResultSize();
  const {
    image: imageSize
  } = TABLE_SIZES[size];
  const connectedAddress = useAddress();
  let t2;
  if ($[2] !== account) {
    t2 = () => {
      if (account.isCompromised) {
        return <AccountEnforcementBadge account={account} className="-ml-1" size={18} />;
      }
      if (account.isVerified) {
        return <AccountLockupBadge className="-ml-1" fill="blue-3" innerFill="white" size={18} />;
      }
      return null;
    };
    $[2] = account;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const renderBadge = t2;
  let t3;
  if ($[4] !== className) {
    t3 = classNames(container(), className);
    $[4] = className;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== imageSize) {
    t4 = <AccountLockupAvatar className="mr-1" size={imageSize} />;
    $[6] = imageSize;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== renderBadge) {
    t5 = renderBadge();
    $[8] = renderBadge;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = connectedAddress ?? null;
  let t7;
  if ($[10] !== account || $[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
    t7 = <AccountLockup account={account} avatar={t4} badge={t5} connectedAddress={t6} displayYou={false} isLink={false} />;
    $[10] = account;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t3 || $[16] !== t7) {
    t8 = <FlexCenter className={t3}>{t7}</FlexCenter>;
    $[15] = t3;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}
export function ExpandedSearchAccountResultSkeleton(t0) {
  const $ = _c(24);
  const {
    index,
    className
  } = t0;
  const size = useExpandedSearchResultSize();
  let T0;
  let T1;
  let imageSize;
  let t1;
  let t2;
  if ($[0] !== className || $[1] !== size) {
    const {
      image
    } = tableRowSizeVariants({
      size
    });
    ({
      image: imageSize
    } = TABLE_SIZES[size]);
    T1 = FlexCenter;
    if ($[7] !== className) {
      t2 = classNames(container(), "gap-2 px-3", className);
      $[7] = className;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    T0 = SkeletonBlock;
    t1 = classNames(image(), "mr-1 aspect-square rounded-full");
    $[0] = className;
    $[1] = size;
    $[2] = T0;
    $[3] = T1;
    $[4] = imageSize;
    $[5] = t1;
    $[6] = t2;
  } else {
    T0 = $[2];
    T1 = $[3];
    imageSize = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  let t3;
  if ($[9] !== imageSize) {
    t3 = {
      width: imageSize,
      height: imageSize,
      minWidth: imageSize,
      minHeight: imageSize
    };
    $[9] = imageSize;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== T0 || $[12] !== t1 || $[13] !== t3) {
    t4 = <T0 className={t1} style={t3} />;
    $[11] = T0;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const t5 = randomAccountNameWidths[index % randomAccountNameWidths.length];
  let t6;
  if ($[15] !== t5) {
    t6 = classNames(t5);
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t6) {
    t7 = <FlexCenter className="w-1/4 gap-1"><TextBodySkeleton className={t6} /></FlexCenter>;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== T1 || $[20] !== t2 || $[21] !== t4 || $[22] !== t7) {
    t8 = <T1 className={t2}>{t4}{t7}</T1>;
    $[19] = T1;
    $[20] = t2;
    $[21] = t4;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}